export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    slug: 'dianshiju',
    name: '热门影视',
    icon: 'ri-movie-2-line',
    description: '最新最热门的电影电视剧资源，高清画质流畅播放',
  },
  {
    slug: 'zongyi',
    name: '综艺娱乐',
    icon: 'ri-emotion-laugh-line',
    description: '热门综艺节目、搞笑娱乐内容一网打尽',
  },
  {
    slug: 'duanshipin',
    name: '短视频',
    icon: 'ri-vidicon-line',
    description: '精彩短视频、创意内容每日更新',
  },
  {
    slug: 'dongman',
    name: '动漫番剧',
    icon: 'ri-ghost-line',
    description: '国内外热门动漫、番剧资源免费在线看',
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    icon: 'ri-earth-line',
    description: '自然、历史、科技纪录片，开阔视野',
  },
  {
    slug: 'tiyu',
    name: '体育赛事',
    icon: 'ri-basketball-line',
    description: '精彩体育赛事回放、集锦高清呈现',
  },
  {
    slug: 'yinyue',
    name: '音乐MV',
    icon: 'ri-music-line',
    description: '热门音乐MV、演唱会现场精彩放送',
  },
  {
    slug: 'jiaoyu',
    name: '教育学习',
    icon: 'ri-book-open-line',
    description: '免费在线课程、知识科普视频资源',
  },
];